import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';

import { PhoneNumberCapability } from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import { initialState as initialStateVoice } from 'src/presentation/components/pages/channels/shared/setupPhoneModal/SetupPhoneModal';
import { initialState as initialStateSms } from 'src/presentation/components/pages/channels/shared/setupPhoneModal/SetupSmsModal';

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useFormChange = (workingSate, updateState) => {
  const prevState = usePrevious(workingSate);
  useEffect(() => {
    if (!isEqual(prevState, workingSate)) {
      updateState(workingSate);
    }
  }, [workingSate, updateState, prevState]);
};

export const useResetFormState = (initialWorkingState, updateState, stateConfig, entityType?) => {
  const prevState = usePrevious(stateConfig);
  const initialState = entityType === PhoneNumberCapability.SMS ? initialStateSms : initialStateVoice;
  const isPreviusStateChange = !isEqual(prevState, stateConfig);
  const isEqualInitialState = isEqual(initialState, stateConfig);
  const needToResetFormState = isPreviusStateChange && isEqualInitialState;
  useEffect(() => {
    if (needToResetFormState && !isUndefined(prevState) && isFunction(updateState)) {
      updateState(initialWorkingState);
    }
  }, [initialWorkingState, updateState, prevState, stateConfig, needToResetFormState]);
};
